import { type ComponentType, type CSSProperties } from 'react';
import * as Lucide from 'lucide-react';

// Lucide renamed a number of glyphs; map the old names the design uses.
const ALIASES: Record<string, string> = {
  'check-circle': 'circle-check',
  'x-circle': 'circle-x',
  'alert-circle': 'circle-alert',
  'alert-triangle': 'triangle-alert',
  'help-circle': 'circle-help',
  'more-horizontal': 'ellipsis',
  'more-vertical': 'ellipsis-vertical',
};

function pascal(name: string): string {
  return name
    .split('-')
    .map((s) => (s ? s[0].toUpperCase() + s.slice(1) : ''))
    .join('');
}

type LucideComp = ComponentType<{ size?: number | string; className?: string; style?: CSSProperties }>;

export interface IconProps {
  name: string;
  size?: number | string;
  style?: CSSProperties;
  className?: string;
}

/** Lucide glyph rendered as a React SVG that inherits currentColor. */
export function Icon({ name, size = '1em', style, className = '' }: IconProps) {
  const real = ALIASES[name] || name;
  const registry = Lucide as unknown as Record<string, LucideComp | undefined>;
  const Cmp = registry[pascal(real)] || registry[pascal(name)] || Lucide.Circle;
  // NOTE: do NOT add the `.zen-icon` class here — that class is for the design's
  // CSS-mask technique (background-color: currentColor) and would paint a solid
  // square over a real <svg>. lucide-react inherits color via stroke on its own.
  return <Cmp size={size} className={className || undefined} style={{ flex: 'none', ...style }} />;
}
